import React, { useEffect, useRef, useState } from "react";

export const Tutorial = ({ objetoTutorial }) => {
  const styleReverse = {
    flexDirection: "row-reverse",
  };
  const styleNormal = {
    flexDirection: "row",
  };

  const ref = useRef();
  const [isVisible, setIsVisible] = useState();

  useEffect(() => {
    const observerSlide = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.4 }
    );
    if (ref.current) {
      observerSlide.observe(ref.current);
    }
    return () => {
      if (ref.current) observerSlide.unobserve(ref.current);
    };
  }, []);
  return (
    <div
      ref={ref}
      className={`${
        objetoTutorial.orientation ? "slide-in-right " : "slide-in-left"
      } ${isVisible ? "visible" : ""}`}
      style={{ backgroundColor: "white" }}
    >
      <div
        style={objetoTutorial.orientation ? styleReverse : styleNormal}
        className="main-tutorial"
      >
        <div className="container-img-tutorial">
          <img
            className="img-tutorial"
            src={objetoTutorial.url}
            alt="screenshot"
            title="img-tutorial"
          />
        </div>
        <div className="tuto-content">
          <h3 className="tutorial-title">{objetoTutorial.title}</h3>
          <p className="tutotial-phara">{objetoTutorial.description}</p>
        </div>
      </div>
    </div>
  );
};

export default Tutorial;
